import { render } from "./PreviewCompositionPage.vue?vue&type=template&id=9a905276&ts=true"
import script from "./PreviewCompositionPage.vue?vue&type=script&lang=ts"
export * from "./PreviewCompositionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__